module.exports = __webpack_public_path__ + "img/idigi-insurrance-logo.f3637f1a.png";